var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSalary = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1701",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 682.7 682.7",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fab29b;\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clippath);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 0,
    width: 682.7,
    height: 682.7
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 430,
    cy: 338,
    r: 147
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1711"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.3,118.1H86c-5.5,0-10-4.5-10-10s4.5-10,10-10h251.3c5.5,0,10,4.5,10,10s-4.5,10-10,10Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1715"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.3,186.8H86c-5.5,0-10-4.5-10-10s4.5-10,10-10h251.3c5.5,0,10,4.5,10,10s-4.5,10-10,10Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1719"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.7,255.5h-125.6c-5.5,0-10-4.5-10-10s4.5-10,10-10h125.6c5.5,0,10,4.5,10,10s-4.5,10-10,10Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1721"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1739"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.5,139.1h-91c-19.4,0-35.2-15.8-35.2-35.2V12.9c0-3.4,1.7-6.6,4.6-8.4s6.5-2.1,9.6-.7c4.6,2.1,8.7,4.9,12.2,8.4l100.6,100.6c3.5,3.5,6.3,7.6,8.4,12.2,1.4,3.1,1.2,6.7-.7,9.6-1.8,2.9-5,4.6-8.4,4.6ZM416.3,34.1v69.7c0,8.4,6.8,15.2,15.2,15.2h69.7l-85-85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1743"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.8,451c-3.6,0-7.1-2-8.9-5.4-11.5-22.3-17.6-47.4-17.6-72.6,0-87.2,70.9-158.2,158.2-158.2s158.2,70.9,158.2,158.2-6.1,50.3-17.6,72.6c-2.5,4.9-8.6,6.8-13.5,4.3-4.9-2.5-6.8-8.6-4.3-13.5,10.2-19.7,15.4-41.1,15.4-63.4,0-76.2-62-138.2-138.2-138.2s-138.2,62-138.2,138.2,5.2,43.7,15.4,63.4c2.5,4.9.6,10.9-4.3,13.5-1.5.8-3,1.1-4.6,1.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1747"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189,682.7H43.2c-23,0-41.7-18.7-41.7-41.7V41.7C1.6,18.7,20.3,0,43.2,0h349.9c11.1,0,21.6,4.3,29.5,12.2l100.5,100.6c7.9,7.9,12.2,18.3,12.2,29.5v58c0,5.5-4.5,10-10,10s-10-4.5-10-10v-58c0-5.8-2.3-11.2-6.4-15.3l-100.5-100.6c-4.1-4.1-9.5-6.4-15.3-6.4H43.2c-12,0-21.7,9.7-21.7,21.7v599.3c0,12,9.7,21.7,21.7,21.7h145.8c5.5,0,10,4.5,10,10s-4.5,10-10,10Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1751"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.2,682.7H253.7c-24.2,0-43.9-19.7-43.9-43.9v-243.4c0-24.2,19.7-43.9,43.9-43.9h44c5.5,0,10,4.5,10,10s-4.5,10-10,10h-44c-13.2,0-23.9,10.7-23.9,23.9v243.4c0,13.2,10.7,23.9,23.9,23.9h383.5c13.2,0,23.9-10.7,23.9-23.9v-243.4c0-13.2-10.7-23.9-23.9-23.9h-44c-5.5,0-10-4.5-10-10s4.5-10,10-10h44c24.2,0,43.9,19.7,43.9,43.9v243.4c0,24.2-19.7,43.9-43.9,43.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1755"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.4,516.5c-2,0-4-.6-5.8-1.8l-181.8-128.7c-4.5-3.2-5.6-9.4-2.4-13.9,3.2-4.5,9.4-5.6,13.9-2.4l181.8,128.7c4.5,3.2,5.6,9.4,2.4,13.9-1.9,2.8-5,4.2-8.2,4.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1759"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.5,516.5c-3.1,0-6.2-1.5-8.2-4.2-3.2-4.5-2.1-10.7,2.4-13.9l181.8-128.7c4.5-3.2,10.7-2.1,13.9,2.4s2.1,10.7-2.4,13.9l-181.8,128.7c-1.8,1.2-3.8,1.8-5.8,1.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1763"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.4,673.5c-2.4,0-4.7-.8-6.7-2.5l-189-168.7c-11-9.8-27.5-9.8-38.5,0l-189,168.7c-4.1,3.7-10.4,3.3-14.1-.8s-3.3-10.4.8-14.1l189-168.7c18.6-16.6,46.6-16.6,65.1,0l189,168.7c4.1,3.7,4.5,10,.8,14.1-2,2.2-4.7,3.3-7.5,3.3Z"
  })))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.8,441.7c-2,0-4-1.1-5.1-2.8l-29.9-45.1c-2.3-3.6-4.7-6.6-7.1-8.9-2.4-2.2-5.3-3.8-8.2-4.7s-6.6-1.3-10.9-1.3h-24.3c-3.4,0-6.2-2.8-6.2-6.2v-2.2c0-3.4,2.8-6.2,6.2-6.2h36.8c11.7,0,20.6-2.4,26.5-7.4,5.5-4.7,8.6-11.3,9.4-20.1.8-8.8.8-1.2,1.5-.8l1.3.8h-75.6c-3.4,0-6.2-2.8-6.2-6.2h0c0-3.4,2.8-6.2,6.2-6.2h75.6l-1.9,1.5c-.5.4-1.5,0-1.6-.5-1.3-6.7-4.7-12-10-15.6-5.7-3.9-13.6-5.9-23.9-5.9h-38.3c-3.4,0-6.2-2.8-6.2-6.2h0c0-3.4,2.8-6.2,6.2-6.2h106.5c3.4,0,6.2,2.8,6.2,6.2h0c0,3.4-2.8,6.2-6.2,6.2h-36.7l3.4-2.3c.3-.1.7-.3,1.1,0,5,2.7,8.9,6.2,11.9,10.5,2.6,3.8,4.3,8.2,5.1,13.2.8,5-.9,1.5-1.6.9h0c-.7-.5-.3-1.8.7-1.8h16.3c3.4,0,6.2,2.8,6.2,6.2h0c0,3.4-2.8,6.2-6.2,6.2h-15.8c-.9,0-1.3-1.1-.7-1.8l.3-.3c.7-.5,1.6,0,1.6.7,0,8.2-1.9,15.4-5.5,21.4-3.9,6.6-9.7,11.7-17.4,15.4-7.5,3.5-16.8,5.3-27.5,5.3v-1.9h4c5.7,0,10.6,1.2,15,3.8,4.3,2.6,8.5,7,12.7,13.3l26,38.9c2.7,4-.3,9.6-5.1,9.6h-8.6v.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSalary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/salary.55da73473424d5e9445c32d1c8bf158f.svg";